import { Injectable } from '@angular/core';

import * as moment from 'moment';
//import { CookieService } from 'ng2-cookies';

import {  CURRENT_ENVIROMENT, SERVICE_END_POINT,
} from '../../../shared';
//import { ConfigLoaderService } from '../config-loader/config-loader.service';
import { WindowService } from './window.service';

interface AnalyticsConfig {
  cms: any;
  page: {
    pageType: string;
    siteSection: string;
    appName: string;
  };
  customer: {
    referenceId: string;
  };
  order: {}; 
  products:{};
  error: ErrorData;
  interaction: any;
  product: any;
  customerRegStatus: any;
  errorDetail: ErrorTrackingData;
  selectedProducts: any;
}

export interface ErrorData {
  pageName?: string;
  type?: string;
  name?: string;
}

export interface ErrorTrackingData {
  formErrorMessage?: string;
  formErrorType?: string;
  formErrorDetail?: string;
  formErrorCount?: number;
}

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {

  
  private endPoints: any;

  private config: AnalyticsConfig = {
    cms: {},
    page: {
      pageType: 'Application',
      siteSection: 'Retirement',
      appName: 'Retirement OQA',
    },
    customer: {
      referenceId: ''
    },
    order: {},
    products:{},
    error: {},
    product: {},
    interaction: {},
    customerRegStatus: {},
    errorDetail: {},
    selectedProducts: {}
  };
  data: any = {};
  window: any;

  constructor(

    // private cookieService: CookieService,
    private windowHelper: WindowService
    // private configLoaderService: ConfigLoaderService,
  ) {
    if (window.location.href.includes('retirements.landg.com'))  {
     this.endPoints = SERVICE_END_POINT['higherEnvironment'];
    } else {
      this.endPoints = SERVICE_END_POINT['localEnvironment'];
    }
    this.window = this.windowHelper.getWindow();
    this.window.digitalData = this.window.digitalData || {};
  }
  initScript() {
    // Data layer has to be defined with at least the app name before the scripts are added to the page
    this.window.digitalData.page = this.config.page;

    const headScript = document.createElement('script');
    headScript.setAttribute('src', this.endPoints.analyticsScript);
    document.head.appendChild(headScript);
  }
  pageTrack(props: any = {}): void {
    this.resetData();

    const { pageName = null, ...pageProps } = props;
    const { href, protocol, hostname, pathname } = this.window.location;
    const URL = href;
    const pageDomain = `${protocol}//${hostname}`;
    const path = pathname;
    const timestamp = moment().format('DD/MM/YYYY HH:mm:ss ddd').toUpperCase();
    const orientation =this.window.screen.height > this.window.screen.width ? 'Portrait' : 'Landscape';
    const screenResolution = `${this.window.screen.width}x${this.window.screen.height}`;
    const previousPage = this.window.digitalData.cms ? this.window.digitalData.cms.pageName : null;
    const nav = (this.window.navigator as any); 
    const language = nav.language || 'unknown';
   // const adobeCookieID = this.getAdobeCookieId();
    const environment = CURRENT_ENVIROMENT.environment;
    const referenceId = this.window.digitalData.customer && this.window.digitalData.customer.referenceId ? this.window.digitalData.customer.referenceId : null;
    const internalReferenceDCJ = this.window.digitalData.order && this.window.digitalData.order.internalReferenceDCJ ? this.window.digitalData.order.internalReferenceDCJ : null;
    const pageData = {
      cms: {
        pageName,
      },
      page: {
        timestamp,
        URL,
        path,
        pageDomain,
        orientation,
        screenResolution,
        language,
        previousPage,
       // adobeCookieID,
        ...pageProps,
      },
      customer: {
        referenceId
      },
      order: {
        
      },
      products:{},
      errorDetail: {},
    };

    const updateEvent = new CustomEvent('yrdAction', {
      detail: pageData,
    });

    this.data = this.createData(pageData);

    // Set the value on the data layer
    this.window.digitalData = this.data;

    // Dispatch event to tell Signal to refresh the data from the data layer
    document.dispatchEvent(updateEvent);
  }

  eventTrack(props: any = {}): void {
    this.data = this.resetInteractionData();
    const interactionData = {
      interaction: {
        ...props,
      },
    };
    const updateEvent = new CustomEvent('yrdAction', {
      detail: interactionData,
    });

    this.data = this.createData(interactionData);
    // Set the value on the data layer
    this.window.digitalData = this.data;

    // Dispatch event to tell Signal to refresh the data from the data layer
    document.dispatchEvent(updateEvent);
  }

  errorTrack(props: ErrorData = {}): void {
    this.data = this.resetErrorData();

    const errorData = {
      error: {
        ...props,
      },
    };
    const updateEvent = new CustomEvent('yrdAction', {
      detail: errorData,
    });

    this.data = this.createData(errorData);

    // Set the value on the data layer
    this.window.digitalData = this.data;

    // Dispatch event to tell Signal to refresh the data from the data layer
    document.dispatchEvent(updateEvent);
  }

  errorAnalyticsTrack(props: ErrorTrackingData = {}): void {
    this.data = this.resetErrorData();
    const errorTrackData = {
      errorDetail: {
        ...props,
      },
    };

    const updateEvent = new CustomEvent('yrdAction', {
      detail: errorTrackData,
    });

    this.data = this.createData(errorTrackData);
    // Set the value on the data layer
    this.window.digitalData = this.data;
   
    // Dispatch event to tell Signal to refresh the data from the data layer
    document.dispatchEvent(updateEvent);
  }

  customerTrack(props: any = {}): void {

    this.data = this.resetCustomerData();

    const customerData = {
      customer: {
        ...props,
      },
    };
    const updateEvent = new CustomEvent('yrdAction', {
      detail: customerData,
    });

    this.data = this.createData(customerData);

    // Set the value on the data layer
    this.window.digitalData = this.data;

    // Dispatch event to tell Signal to refresh the data from the data layer
    document.dispatchEvent(updateEvent);
  }

  orderTrack(props: any = {}): void {

    this.data = this.restOrderData();

    const orderData = {
      order: {
        ...props,
      },
    };
    const updateEvent = new CustomEvent('yrdAction', {
      detail: orderData,
    });

    this.data = this.createData(orderData);

    
    // Set the value on the data layer
    this.window.digitalData = this.data;
   
    // Dispatch event to tell Signal to refresh the data from the data layer
    document.dispatchEvent(updateEvent);

   
  }

  productsTrack(props: any = {}): void {

    this.data = this.restProductsData();

    const productsData = {
      products: {
        ...props,
      },
    };
   
    const updateEvent = new CustomEvent('yrdAction', {
      detail: productsData,
    });

    this.data = this.createData(productsData);

    

    // Set the value on the data layer
    this.window.digitalData = this.data;
   
    // Dispatch event to tell Signal to refresh the data from the data layer
    document.dispatchEvent(updateEvent);

    
  }

  // eventTrack(props: any = {}): void {
  //   this.data = this.resetInteractionData();
  //   const interactionData = {
  //     interaction: {
  //       ...props,
  //     },
  //   };
  //   const updateEvent = new CustomEvent('yrdAction', {
  //     detail: interactionData,
  //   });

  //   this.data = this.createData(interactionData);
  //   // Set the value on the data layer
  //   this.window.digitalData = this.data;

  //   // Dispatch event to tell Signal to refresh the data from the data layer
  //   document.dispatchEvent(updateEvent);
  // }

  selectedProductsTrack(props: any = {}): void {
      this.data = this.resetSelectedProductsData();

      const selectedProductsData = {
        selectedProducts: {
          ...props,
        },
    };

    const updateEvent = new CustomEvent('yrdAction', {
      detail: selectedProductsData,
    });

    this.data = this.createData(selectedProductsData);

    // Set the value on the data layer
    this.window.digitalData = this.data;
  
    // Dispatch event to tell Signal to refresh the data from the data layer
    document.dispatchEvent(updateEvent);
  }


  customerStatusTrack(props: any = {}): void {
    this.data = this.resetCustomerStatusData();

    const customerStatusData = {
      customerRegStatus: {
        ...props,
      },
    };
   
    const updateEvent = new CustomEvent('yrdAction', {
      detail: customerStatusData,
    });

    this.data = this.createData(customerStatusData);

    // Set the value on the data layer
    this.window.digitalData = this.data;
   
    // Dispatch event to tell Signal to refresh the data from the data layer
    document.dispatchEvent(updateEvent);
  }

  createData(nextProps: any = {}): any {
    return Object.keys(this.config).reduce((acc, key) => {
      const hasNextData = nextProps[key] && Object.keys(nextProps[key]).length;
      const hasKeyData = this.data[key] && Object.keys(this.data[key]).length;

      if (hasNextData || hasKeyData) {
        return {
          ...acc,
          [key]: {
            ...this.data[key],
            ...this.config[key],
            ...nextProps[key],
          },
        };
      }

      return acc;
    }, {});
  }

  resetData(): any {
    if (Object.keys(this.data).length) {
      if (this.data.page && Object.keys(this.data.page).length) {
        const { page } = this.data;
        const { topBanners, bottomBanners, sideBanners, ...rest } = page;
        this.data = {
          ...this.data,
          page: {
            ...rest,
          },
        };
      }

      this.data = {
        ...this.data,
      };
    }
  }

  resetInteractionData(): {} {
    return {
      ...this.data,
      interaction: {},
    };
  }

  resetCustomerData(): {} {
    return {
      ...this.data,
      customer: {},
    };
  }

  restOrderData(): {} {
    return {
      ...this.data,
      order: {},
    };
  }

  restProductsData(): {} {
    return {
      ...this.data,
      products: {},
    };
  }
  
  resetErrorData(): {} {
    return {
      ...this.data,
      error: {},
    };
  }

  resetCustomerStatusData(): {} {
    return {
      ...this.data,
      customerRegStatus: {},
    };
  }

  resetSelectedProductsData(): {} {
    return {
      ...this.data,
      selectedProducts: {},
    };
  }


/*
  // The Adobe visitor ID is stored in an AMCV_###@AdobeOrg cookie
  // on the domain of the current website, where ### represents a random string of characters.
  // For example, AMCV_1FD6776A524453CC0A490D44%40AdobeOrg.
  getAdobeCookieId(): string {
    const cookies = this.cookieService.getAll();
    const adobeCookieRegExp = /AMCV_(.*)(@|%40)AdobeOrg/;
    return Object.keys(cookies)
      .reduce((acc, key) => {
        if (key.search(adobeCookieRegExp) !== -1) {
          return [ ...acc, cookies[key] ];
        }
        return acc;
      }, [])
      .pop();
  }
  */

 
}
